export const CONSTANTS = {

    VALIDATION_TYPE: {
        NUMERIC: '[0-9]{0,}',
        ALPHA_NUMERIC: '[A-Za-z0-9 ]+'
    },

    FIELD_LENGTH: {
        LAST_4_DIGITS: 4
    }

};
